// eslint-disable-next-line jira/filename-case
import { getCollectionViewPageUrl } from '@jira/polaris__component-collections/src/getCollectionsPageUrl.tsx';
import type { NavigationCollection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/types.tsx';
import type { GetViewUrl } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/controllers/types.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

/**
 * Returns `collectionUUID` and `viewUUID` of currently visible collection, otherwise `undefined`
 */
// oxlint-disable-next-line typescript/no-invalid-void-type
export const useCollectionSelectedMatch: (args_0: void) =>
	| {
			collectionUUID: string;
			viewUUID: string;
	  }
	| undefined = createRouterSelector(({ route, match }) => {
	const viewUUID = match.params?.resource || undefined;
	const collectionUUID = match.params?.collectionUUID || undefined;

	const isCollectionSelected =
		route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;

	return isCollectionSelected ? { collectionUUID, viewUUID } : undefined;
});

/**
 * Returns `true` if user is on `/jira/polaris/roadmaps`, otherwise `false`
 */
// oxlint-disable-next-line typescript/no-invalid-void-type
export const useIsCollectionsSelected: (args_0: void) => boolean = createRouterSelector(
	({ route, match }) => {
		const viewUUID = match.params?.resource || undefined;
		const collectionUUID = match.params?.collectionUUID || undefined;

		return (
			route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined
		);
	},
);

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useIsJpdProjectView: (args_0: void) => boolean = createRouterSelector(
	({ route, match }) => {
		const viewUUID = match.params?.resource || undefined;

		return route.name === 'polaris-ideas' && viewUUID !== undefined;
	},
);

type UseIsCollectionSelectedOptions = {
	collectionUUID: string;
};

/**
 * Returns `true` if user is on collection with view.
 * When `options` are defined, returns `true` if `collectionUUID` matches.
 * Otherwise `false`
 */
export const useIsCollectionSelected = (
	options?: UseIsCollectionSelectedOptions,
): boolean | undefined => {
	const collectionMatched = useCollectionSelectedMatch();

	if (options?.collectionUUID) {
		return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
	}

	return Boolean(collectionMatched);
};

export const getViewUrl: GetViewUrl<NavigationCollection> = ({ container, view }) => {
	// In collections we don't use `view.polarisId` like we do in jpd-project-menu
	// but instead we use `view.id` that contains UUID
	return getCollectionViewPageUrl(container.collectionUUID, view.id);
};
